// extracted by mini-css-extract-plugin
export default {"initial_text":"ReportBuilder_initial_text__3Vxbu"};